<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'TIPORESPALDO.LBL_TIPORESPALDO' | translate}}</h1>
    </div>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'TIPORESPALDO.LBL_IDENTTIPRES' | translate }}" [selected]="tabSeleccionado === 'RESP'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">

            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'LBL_CODIGO' | translate }}</label>
                  <div *ngIf="!tipoRespaldo">
                    <input type="text" pInputText id="codigo"
                           name="nomCodigo"
                           autocomplete="off"
                           formControlName="codigo" codigos-reactive
                           (blur)="validarCodigo()"
                           [maxlength]="6"

                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                      {{ 'LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <div *ngIf="tipoRespaldo && tipoRespaldo.idTipoRespaldo">
                    <label class="falso-combo-texto">{{tipoRespaldo.codigo}}</label>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         capitalize-reactive
                         [maxlength]="100"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-12 lg:col-12">
                <div class="div-form">
                  <label>* {{ 'TIPORESPALDO.LBL_DESTIPRES' | translate }}</label>
                  <textarea pInputTextarea type="text" pInputText id="descripcion"
                            name="nomDescripcion"
                            autocomplete="off"
                            formControlName="descripcion"
                            capitalize-reactive
                            [maxlength]="500"
                  ></textarea>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                    {{ 'TIPORESPALDO.LBL_DESTIPRES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>


            <div class="grid form-group">
              <div class="col-12 md:col-2 lg:col-2">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicadorHabilitado"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>

            <div class="grid form-footer-buttons" *ngIf="tipoRespaldo">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus" label="{{'BTN_ACTUALIZAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="grid form-footer-buttons" *ngIf="!tipoRespaldo">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TIPORESPALDO.LBL_AGRCATEGORIA' | translate }}" [selected]="tabSeleccionado === 'CATE'"
                        [disabled]="!tipoRespaldo"
                        *ngIf="tipoRespaldo && tipoRespaldo.idTipoRespaldo">
          <app-tipo-respaldo-categoria [tipoRespaldo]="tipoRespaldo" (respaldoCategoriaEvent)="recibirCategoria($event)" (tabEvent)="recibirTabSubcategoria($event)"
                                       (dismiss)="cambiarTabSeleccionado($event)"></app-tipo-respaldo-categoria>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TIPORESPALDO.LBL_AGRSUBCAT' | translate }}" [selected]="tabSeleccionado === 'SUBC'"
                        [disabled]="!respaldoCategoria"
                        *ngIf="respaldoCategoria && respaldoCategoria.idTipoRespaldoCategoria && respaldoCategoria.indicadorSubcategoria">
          <app-tipo-respaldo-subcategoria [respaldoCategoria]="respaldoCategoria" (respaldoSubcategoriaEvent)="recibirSubcategoria($event)" (tabEvent)="recibirTabClase($event)"
                                          (dismiss)="cambiarTabSeleccionado($event)"></app-tipo-respaldo-subcategoria>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TIPORESPALDO.LBL_AGRCYSC' | translate }}" [selected]="tabSeleccionado === 'CLAS'"
                        [disabled]="!respaldoSubcategoria"
                        *ngIf="respaldoSubcategoria && respaldoSubcategoria.idTipoRespaldoSubCategoria">
          <app-tipo-respaldo-clase [respaldoSubcategoria]="respaldoSubcategoria"
                                   (dismiss)="cambiarTabSeleccionado($event)"></app-tipo-respaldo-clase>
        </p-accordionTab>

      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="tipoRespaldo && tipoRespaldo.idTipoRespaldo">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
